import React, { useEffect } from "react";
import Body from "@appsinti/stats-frontend/home/components/Body";
import { useData } from "../../../../data";
import { Ring } from "@uiball/loaders";
import { BG_DARK } from "@etiquette-ui/colors";
import LineChart from "../../../../components/charts/line";
import BarChart from "../../../../components/charts/bar";
import IChartData from "../../../../../interfaces/IChartData";

const Graph: React.FC = () => {
  const { sales, fetchSales, loading } = useData();

  useEffect(() => {
    fetchSales();
  }, []);


  return sales?.length && !loading ? (
    <Body>
      {sales.map((graph: IChartData | null, index: React.Key | null | undefined) => {
        if (!graph) return null;
        if (graph.type === "line") {
          return (
            <LineChart
              key={index}
              dataObject={graph}
            />
          );
        }

        if (graph.type === "bar") {
          return (
            <BarChart
              key={index}
              dataObject={graph}
            />
          );
        }
        return null;
      })}
    </Body>
  ) : (
    <Body style={{ display: "flex", justifyContent: "center" }}>
      <Ring color={BG_DARK} size={50} />
    </Body>
  );
};

export default Graph;
